import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { ImageAnnotation } from "models/interfaces/block-configurations/image-annotation";

const defaultValues: ImageAnnotation =
    RecordUtils.auditableDefaultValuesFactory<ImageAnnotation>({
        imageBlockId: undefined,
        coordinateX: undefined,
        coordinateY: undefined,
        note: "",
        sortIndex: undefined,
    });

export class ImageAnnotationRecord
    extends Record(defaultValues)
    implements ImageAnnotation
{
    constructor(params?: Partial<ImageAnnotation>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }
        super(params);
    }

    public toInlineStyles(): React.CSSProperties {
        if (this.coordinateX == null || this.coordinateY == null) {
            return {};
        }

        return {
            left: `${this.coordinateX * 100}%`,
            top: `${this.coordinateY * 100}%`,
        };
    }

    public with(values: Partial<ImageAnnotation>): ImageAnnotationRecord {
        return new ImageAnnotationRecord(Object.assign(this.toJS(), values));
    }
}
